export default __webpack_public_path__ + "static/media/judoLogo.a0cf9e1d.png";